export default __webpack_public_path__ + "static/media/mongodb-icon.abda0740.png";